import { tokens } from '../../tokens';

interface Props {
  /** Fraction (0..1) of total balance value held in stable. */
  stableFraction: number;
  width?: number | string;
}

const BalancePill = ({ stableFraction, width = 80 }: Props) => {
  const stablePercent = Math.round(
    Math.min(1, Math.max(0, stableFraction)) * 100,
  );
  const assetPercent = 100 - stablePercent;
  return (
    <div style={{ width }}>
      <div
        style={{
          display: 'flex',
          height: 8,
          borderRadius: 4,
          overflow: 'hidden',
          background: tokens.backgroundElevated,
        }}
      >
        <div style={{ width: `${stablePercent}%`, background: tokens.red }} />
        <div style={{ width: `${assetPercent}%`, background: tokens.green }} />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 3,
          fontSize: 9,
          fontFamily: tokens.fontMono,
          letterSpacing: '0.04em',
        }}
      >
        <span style={{ color: tokens.red }} title="Stable">
          {stablePercent}%
        </span>
        <span style={{ color: tokens.green }} title="Asset">
          {assetPercent}%
        </span>
      </div>
    </div>
  );
};

export default BalancePill;
